/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Due_Date_TitleInputs */



/**
* | output |
* | --- |
* | "Set Due Date" |
*
* @param {Explorer_Info_Due_Date_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_title = /** @type {((inputs?: Explorer_Info_Due_Date_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set Due Date")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set Due Date")
	return /** @type {LocalizedString} */ ("Set Due Date")
});